import { useCallback } from 'react';

import { fg } from '@confluence/feature-gating';
import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';
import { useSiteTraits } from '@confluence/targeting/entry-points/useSiteTraits.ts';

const LOOM_AUTO_PROVISION_TRAIT_NAME = 'loom.auto-provision.activationDate';

export const useIsLoomAutoProvisionEnabled = () => {
	// 1. check trait 'loom.auto-provision.activationDate' is set against the SITE
	// Skip this expensive site traits lookup if feature is disabled
	const { data: siteTraits } = useSiteTraits({
		skipBootstrap: !fg('loom_post_ap_add_spotlight_to_confluence_couse'),
	});
	const hasGrantedApLoomAccessDateTrait =
		fg('loom_post_ap_add_spotlight_to_confluence_couse') &&
		(siteTraits?.attributes?.some((attr) => attr.name === LOOM_AUTO_PROVISION_TRAIT_NAME) ?? false);

	// 2. check if there is 'seen' value set in the local storage (persisted to backend)
	// Skip this localStorage lookup if feature is disabled or trait is missing
	const hasSeenSpotlight =
		hasGrantedApLoomAccessDateTrait && fg('loom_post_ap_add_spotlight_to_confluence_couse')
			? !!localStorage.getItem(
					PERSISTED_KEYS_ON_SERVER.PERSISTED_LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN,
				)
			: false;

	const isLoomAutoProvisionEnabled =
		hasGrantedApLoomAccessDateTrait &&
		!hasSeenSpotlight &&
		fg('loom_post_ap_add_spotlight_to_confluence_couse');

	const setSeenSpotlight = useCallback(() => {
		localStorage.setItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_LOOM_AUTO_PROVISION_SPOTLIGHT_SEEN,
			'true',
		);
	}, []);

	return { isLoomAutoProvisionEnabled, setSeenSpotlight };
};
